import session from '@/api/session';

export default {
  sendTrustpilotReviewEmail(account_id) {
    return session.post(`/accounts/${account_id}/actions/send-trust-pilot-review-email/`);
  }
};
